import { MasterTranslation } from '@/constants';
import { useGlobalState } from '@/hooks';
import type { IShipmentData, ITrackingEventDateOptions } from '@/modules/pmt/interfaces';
import { trackingEventDateModify } from '@/modules/pmt/utils';
import { DetailLeftContainer, SubTitle, Time, Title } from '../../TrackingEventCardHeader.styles';
import { useWaitingTrackingInfoCopy } from '../../hooks';

const parcelDateFormatOptions: ITrackingEventDateOptions = {
  showDate: true,
  showTime: true,
  fullDay: false,
  showDay: true,
  isFormatTimeUnderOneDay: true,
};

export interface ITrackingEventPendingProps {
  trackingDetails?: IShipmentData;
}

const TrackingEventPending = ({ trackingDetails }: ITrackingEventPendingProps) => {
  const { t } = useGlobalState();
  const shipmentImportedDate = trackingDetails?.shipmentImportedDate ?? new Date().toISOString();
  const waitingTrackingInfo = useWaitingTrackingInfoCopy();

  return (
    <DetailLeftContainer>
      <Time>{trackingEventDateModify(shipmentImportedDate, parcelDateFormatOptions, t)}</Time>
      <Title>{t(MasterTranslation.ToShip)}</Title>
      <SubTitle>{waitingTrackingInfo}</SubTitle>
    </DetailLeftContainer>
  );
};

export { TrackingEventPending };
